import { useEffect, useState } from 'react';

export function resolvePremiumPrice(app, now = Date.now(), additionalSellers = 0) {
  const normalPrice = Number(app.normalPrice ?? app.price ?? 0);
  const promotional = Number.isFinite(app.promotionalPrice) && Number.isFinite(Date.parse(app.promotionEndsAt)) && now < Date.parse(app.promotionEndsAt);
  const annualPromotional = Number.isFinite(app.annualPromotionalPrice) && Number.isFinite(Date.parse(app.promotionEndsAt)) && now < Date.parse(app.promotionEndsAt);
  const annualPrice = annualPromotional ? app.annualPromotionalPrice : null;
  const basePrice = promotional ? app.promotionalPrice : normalPrice;
  return { normalPrice, basePrice, promotional, annualPromotional, annualPrice, total: basePrice + Math.max(0, additionalSellers) * (app.additionalSellerPrice || 0) };
}

export function usePremiumPrice(app, additionalSellers = 0) {
  const [now, setNow] = useState(Date.now);
  useEffect(() => {
    let timer;
    const deadline = Date.parse(app.promotionEndsAt);
    const refresh = () => {
      const timestamp = Date.now();
      setNow(timestamp);
      clearTimeout(timer);
      if (deadline > timestamp) timer = setTimeout(refresh, Math.min(deadline - timestamp, 2147483647));
    };
    refresh();
    window.addEventListener('focus', refresh);
    return () => { clearTimeout(timer); window.removeEventListener('focus', refresh); };
  }, [app.promotionEndsAt]);
  return resolvePremiumPrice(app, now, additionalSellers);
}
